module.exports = __webpack_public_path__ + "img/logo@2x.6ee060b0.png";